var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16 / Launch-icon",
    clipPath: "url(#clip0_0_37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.093 8C14.0934 8.16977 14.0499 8.33675 13.9667 8.48471C13.8834 8.63268 13.7633 8.75658 13.618 8.84437L4.61302 14.3531C4.4612 14.4461 4.28731 14.4968 4.10932 14.5001C3.93133 14.5034 3.75568 14.4592 3.60052 14.3719C3.44684 14.2859 3.31882 14.1606 3.22962 14.0088C3.14043 13.857 3.09328 13.6842 3.09302 13.5081V2.49188C3.09328 2.3158 3.14043 2.14298 3.22962 1.99117C3.31882 1.83936 3.44684 1.71405 3.60052 1.62813C3.75568 1.54084 3.93133 1.49656 4.10932 1.49986C4.28731 1.50316 4.4612 1.55391 4.61302 1.64688L13.618 7.15562C13.7633 7.24342 13.8834 7.36732 13.9667 7.51529C14.0499 7.66325 14.0934 7.83023 14.093 8Z",
    fill: "var(--fill-0, #31ADFF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.2d4b58f8ad64db3db43a54dceaab01ca.svg";
export { ForwardRef as ReactComponent };